import Loadable from 'react-loadable';

export const PhotoSessionsLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "photoSessions" */ './index'),
  loading: () => null,
});
